import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Info, AlertTriangle, CheckCircle2, Zap, Megaphone } from "lucide-react";

const TONE_MAP = {
  info:    { icon: Info,          cls: "text-blue-600 dark:text-blue-400" },
  success: { icon: CheckCircle2,  cls: "text-emerald-600 dark:text-emerald-400" },
  warning: { icon: AlertTriangle, cls: "text-amber-600 dark:text-amber-400" },
  urgent:  { icon: Zap,           cls: "text-rose-600 dark:text-rose-400" },
};

export default function BroadcastPopup({ user }) {
  const [queue, setQueue] = useState([]);

  useEffect(() => {
    if (!user) return;
    api.get("/broadcasts/active").then((r) => setQueue(r.data.items || [])).catch(() => {});
  }, [user]);

  const current = queue[0];
  const dismiss = async () => {
    if (!current) return;
    try { await api.post(`/broadcasts/${current.id}/dismiss`); } catch { /* ignore */ }
    setQueue((q) => q.slice(1));
  };

  if (!current) return null;
  const tone = TONE_MAP[current.tone] || TONE_MAP.info;
  const Icon = tone.icon;

  return (
    <Dialog open={!!current} onOpenChange={(v) => { if (!v) dismiss(); }}>
      <DialogContent className="max-w-md" data-testid="broadcast-popup">
        <DialogHeader>
          <div className="flex items-center gap-2 mb-1">
            <div className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-[#B78E4C]/10 text-[#B78E4C] text-[10px] font-medium uppercase tracking-widest">
              <Megaphone className="h-3 w-3" /> Announcement
            </div>
            {queue.length > 1 && (
              <span className="text-[10px] text-muted-foreground font-mono">
                {queue.length} pending
              </span>
            )}
          </div>
          <DialogTitle className="font-display text-2xl flex items-center gap-2">
            <Icon className={`h-5 w-5 ${tone.cls}`} />
            {current.title}
          </DialogTitle>
          <DialogDescription className="whitespace-pre-wrap text-base pt-2 text-foreground/80">
            {current.body}
          </DialogDescription>
        </DialogHeader>
        <div className="text-[10px] uppercase tracking-widest text-muted-foreground">
          from {current.created_by_name}
        </div>
        <DialogFooter>
          <Button onClick={dismiss} data-testid="broadcast-dismiss" className="bg-[#0B192C] hover:bg-[#0B192C]/90 text-white">
            Got it
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
